import { createContext, useContext } from 'react';

/**
 * Общий «мозг» приложения. App.js остаётся владельцем состояния и обработчиков,
 * но прокидывает их сюда, чтобы любая тема-оболочка (classic / nova / …) могла
 * читать данные и вызывать действия, не завися от разметки конкретной темы.
 *
 * Тема НЕ хранит своё состояние — она только рисует. Это позволяет добавлять
 * кардинально разные оболочки, не раздувая App.js и не дублируя логику.
 */
const AppContext = createContext(null);

export function AppProvider({ value, children }) {
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppContext() {
    const ctx = useContext(AppContext);
    if (ctx === null) {
        throw new Error('useAppContext должен вызываться внутри <AppProvider>');
    }
    return ctx;
}

export default AppContext;
